// extracted by mini-css-extract-plugin
export var childrenContainer = "_bn-0";